<template>
  <div>
    <b-row>
      <b-col cols="md-6">
        <vue-good-table
          :columns="columns"
          @on-row-click="onRowClick"
          :rows="rows"
          :search-options="{
    enabled: true
  }"
        ></vue-good-table>
      </b-col>
      <b-col cols="md-6">
        <div id="info-box-chi">選擇事故類別以閱覽條款細則。</div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "PolicyChi",
  components: {},
  methods: {
    onRowClick(params) {
      var info = document.getElementById("info-box-chi");
      info.innerHTML = "<p><b>" + "條款編號" + params.row.clause + "</b></p>";

      if (params.row.description) {
        // info.innerHTML += "<br>";
        for (var i = 0; i < params.row.description.length; i++) {
          info.innerHTML += "<li>" + params.row.description[i] + "</li>";
        }
      } else {
        // info.innerHTML += "<br>";
        info.innerHTML += "<i>此項條款沒有描述。</i>";
      }

      if (params.row.link) {
        info.innerHTML +=
          '<br> <a target="_blank" href=' +
          params.row.link +
          ">" +
          "閱覽參考文件" +
          "</a>";
      }
    }
  },
  data() {
    return {
      columns: [
        {
          label: "事故類別",
          field: "category"
        },
        {
          label: "條款編號",
          field: "clause"
        }
      ],
      rows: [
        {
          id: 1,
          category: "對病人的專業責任",
          clause: "1-4",
          link:
            "https://www.mchk.org.hk/english/code/files/Code_of_Professional_Conduct_2016_c.pdf#page=11",
          description: [
            "1.1 醫療記錄",
            "1.2 體格檢驗及其後發出報告",
            "1.3 轉介病人或終止執業時處理醫療記錄的方法",
            "1.4 向第三者披露醫療資料",
            "2.10 建議治療與風險的恰當解釋",
            "2.11 拒絕聽取醫生解釋的病人",
            "2.12 兒童病人",
            "2.1.3 失去知覺的病人",
            "4.3 嚴重傳染病"
          ]
        },
        {
          id: 2,
          category: "專業上的信息交流",
          clause: "5-8",
          link:
            "https://www.mchk.org.hk/english/code/files/Code_of_Professional_Conduct_2016_c.pdf#page=14",
          description: [
            "5.1 良好信息交流及獲取資料的需要",
            "5.2 有關良好信息交流及資料發布的原則及規則"
          ]
        },
        {
          id: 3,
          category: "藥物",
          clause: "9-11"
        },
        {
          id: 4,
          category: "財務安排",
          clause: "12-16",
          link:
            "https://www.mchk.org.hk/english/code/files/Code_of_Professional_Conduct_2016_c.pdf#page=31",
          description: [
            "13.2 合約醫療及醫療服務機構",
            "15.5 藥物及儀器的臨試驗"
          ]
        },
        {
          id: 5,
          category: "與同業及機構的關係",
          clause: "17-21"
        },
        {
          id: 6,
          category: "新醫學程序、臨研究及另類療法",
          clause: "22-24"
        },
        {
          id: 7,
          category: "濫用專業地位",
          clause: "25-26"
        },
        {
          id: 8,
          category: "刑事記錄和紀律程序",
          clause: "27-29"
        },
        {
          id: 9,
          category: "嚴重的傳染病",
          clause: "30-32"
        },
        {
          id: 10,
          category: "特別範疇",
          clause: "33-36"
        }
      ]
    };
  }
};
</script>


<style scoped>
#info-box-chi {
  text-align: left;
}

a:hover {
  text-decoration: none !important;
}
</style>